import { Radio, Stack, Typography } from "@mui/material";
import React from "react";

const AddressCard = ({
  showButton = true,
  cardData,
  selectedValue,
  handleChange,
}) => {
  return (
    <Stack
      p={2}
      border={"1px solid"}
      borderColor={"text.borderGrey"}
      borderRadius={1}
    >
      <Stack direction={"row"} alignItems={"center"}>
        <Radio
          value={cardData._id}
          checked={selectedValue === cardData._id}
          onChange={handleChange}
        />

        <Typography variant="body1">{`${cardData.firstname} ${cardData.lastname}`}</Typography>
        <Typography variant="body1" ml={2}>
          {cardData.contact}
        </Typography>
      </Stack>
      <Typography variant="body2" ml={5}>
        {cardData.email}
      </Typography>
      <Typography variant="body2" ml={5}>
        {cardData.address}
      </Typography>

      <Typography variant="body2" color={"text.coolGrey"} ml={5}>
        {cardData.country} / {cardData.state} / {cardData.city} /{" "}
        {cardData.zipCode}
      </Typography>
    </Stack>
  );
};

export default AddressCard;
